import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Select, SelectItem } from '@repo/design-system/components/ui/select';
import { useAppDispatch, useAppSelector } from '@repo/store/maps/hooks';
import { selectMapData, selectSelectedRegionId, setSelectedRegionId } from '@repo/store/maps/slices/mapData';
import { useState } from 'react';
import { useRegionOperations } from '../../game-map/hooks/useRegionOperations';
export const RegionTools = () => {
  const $ = _c(21);
  const dispatch = useAppDispatch();
  const mapData = useAppSelector(selectMapData);
  const selectedRegionIdFromRedux = useAppSelector(selectSelectedRegionId);
  const {
    startDrawingRegion,
    stopDrawingRegion,
    isCreating
  } = useRegionOperations();
  const [isDrawing, setIsDrawing] = useState(false);
  let t0;
  if ($[0] !== mapData?.regions?.features) {
    t0 = mapData?.regions?.features || [];
    $[0] = mapData?.regions?.features;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const regions = t0;
  let t1;
  if ($[2] !== startDrawingRegion) {
    t1 = () => {
      setIsDrawing(true);
      startDrawingRegion();
    };
    $[2] = startDrawingRegion;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleStartDrawing = t1;
  let t2;
  if ($[4] !== stopDrawingRegion) {
    t2 = () => {
      setIsDrawing(false);
      stopDrawingRegion();
    };
    $[4] = stopDrawingRegion;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleStopDrawing = t2;
  let t3;
  if ($[6] !== dispatch) {
    t3 = regionId => {
      dispatch(setSelectedRegionId(regionId));
    };
    $[6] = dispatch;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleRegionSelect = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div>Draw New Region</div>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== handleStartDrawing || $[10] !== handleStopDrawing || $[11] !== isCreating || $[12] !== isDrawing) {
    t5 = <FlexColumn gap="8">{t4}<FlexRow gap="8">{!isDrawing ? <Button onClick={handleStartDrawing} variant="filled" color="brand" size="sm" disabled={isCreating}>Start Drawing</Button> : <Button onClick={handleStopDrawing} variant="filled" color="error" size="sm">Cancel Drawing</Button>}</FlexRow></FlexColumn>;
    $[9] = handleStartDrawing;
    $[10] = handleStopDrawing;
    $[11] = isCreating;
    $[12] = isDrawing;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== handleRegionSelect || $[15] !== regions || $[16] !== selectedRegionIdFromRedux) {
    t6 = regions.length > 0 && <FlexColumn gap="8"><div>Edit Existing Region</div><Select value={selectedRegionIdFromRedux ?? undefined} onValueChange={handleRegionSelect} placeholder="Select a region" size="sm" fullWidth={true} trigger={<Button color="primary" size="sm">{selectedRegionIdFromRedux ? regions.find(r => r.properties.externalId === selectedRegionIdFromRedux)?.properties.title || "Unnamed Region" : "Select a region"}</Button>}>{regions.map(_temp)}</Select></FlexColumn>;
    $[14] = handleRegionSelect;
    $[15] = regions;
    $[16] = selectedRegionIdFromRedux;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <FlexColumn gap="12">{t5}{t6}</FlexColumn>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
function _temp(region) {
  return <SelectItem key={region.properties.externalId} item={{
    label: region.properties.title || "Unnamed Region",
    value: region.properties.externalId
  }}>{region.properties.title || "Unnamed Region"}</SelectItem>;
}